export const SET_COMMISSION_DETAILS = 'SET_COMMISSION_DETAILS';
export const SET_COMMISSION_PAGINATION_DETAILS = 'SET_COMMISSION_PAGINATION_DETAILS';
export const SET_COMMISSION_DETAILS_LOADING = 'SET_COMMISSION_DETAILS_LOADING';
export const COMMISSION_DETAILS_FETCH_FAILED = 'COMMISSION_DETAILS_FETCH_FAILED';
export const COMMISSION_PAGINATION_DETAILS_FETCH_FAILED = 'COMMISSION_PAGINATION_DETAILS_FETCH_FAILED';
export const RESET_COMMISSIONS_DETAILS = 'RESET_COMMISSIONS_DETAILS';
export const SET_USERAGENT_DETAILS = 'SET_USERAGENT_DETAILS';
export const SET_USERAGENT_DETAILS_LOADING = 'SET_USERAGENT_DETAILS_LOADING';
export const USERAGENT_FETCH_FAILED = 'USERAGENT_DETAILS_FETCH_FAILED';
export const SET_MODAL_CONTENT = 'SET_MODAL_CONTENT';
export const COMMISSIONS_DETAILS_INSIGHT = 'COMMISSIONS_DETAILS_INSIGHT';
export const COMMISSIONS_DETAILS_INSIGHT_FAILED = 'COMMISSIONS_DETAILS_INSIGHT_FAILED';
export const SET_USERAGENT_LIST = 'SET_USERAGENT_LIST';
export const COMMISSIONS_DETAILS_SEARCH = 'COMMISSIONS_DETAILS_SEARCH';
export const COMMISSIONS_DETAILS_SEARCH_FAILED = 'COMMISSIONS_DETAILS_SEARCH_FAILED';

// New Action Types
export const SET_COMMISSIONS_REST_PROPS = 'SET_COMMISSIONS_REST_PROPS';

export const REQUEST_COMMISSIONS_DETAILS_INSIGHT = 'REQUEST_COMMISSIONS_DETAILS_INSIGHT';
export const RECEIVE_COMMISSIONS_DETAILS_INSIGHT = 'RECEIVE_COMMISSIONS_DETAILS_INSIGHT';
export const COMMISSIONS_DETAILS_INSIGHT_SERVICE_ERROR = 'COMMISSIONS_DETAILS_INSIGHT_SERVICE_ERROR';

export const REQUEST_COMMISSIONS_DETAILS = 'REQUEST_COMMISSIONS_DETAILS';
export const RECEIVE_COMMISSIONS_DETAILS = 'RECEIVE_COMMISSIONS_DETAILS';
export const CONCAT_COMMISSIONS_DETAILS = 'CONCAT_COMMISSIONS_DETAILS';
export const COMMISSIONS_DETAILS_SERVICE_ERROR = 'COMMISSIONS_DETAILS_SERVICE_ERROR';

export const SET_COMMISSIONS_DETAILS_PAGE_NUMBER = 'SET_COMMISSIONS_DETAILS_PAGE_NUMBER';
export const SET_COMMISSIONS_DETAILS_SEARCH_DETAILS = 'SET_COMMISSIONS_DETAILS_SEARCH_DETAILS';
export const SET_COMMISSIONS_DETAILS_REST_PROPS = 'SET_COMMISSIONS_DETAILS_REST_PROPS';
